<script src="https://js.stripe.com/v3" async></script>
<script src="https://cdn.plaid.com/link/v2/stable/link-initialize.js"></script>
<script>
import CreditCardElement from "@/components/CreditCardElement";
import PlaidLink from "@/components/PlaidLink";
export default {
  components: {
    CreditCardElement,
    PlaidLink,
  },
  props: {
    // An ID for the modal element, to be used with v-b-modal.the-id
    modalId: {
      type: String,
      default: "stripeModal",
    },
    payment_methods: {
      type: Array,
      default: [],
    },
    default: {
      type: Object,
      default: {},
    },
  },
  methods: {
    // Hides main modal
    hide() {
      this.$refs.mainModal.hide();
    },
    // Hides modal for adding new payment method
    hideNewModal() {
      this.$refs.newPM.hide();
    },
    // Hide the add existing payment method modal
    hideExistingModal() {
      this.$refs.existingPM.hide();
    },
    // for rendering credit card details
    formatCardDetails(pm) {
      let nameCapitalized =
        pm.card.brand.charAt(0).toUpperCase() + pm.card.brand.slice(1);
      return `${nameCapitalized} ending in ${pm.card.last4} (Exp. ${pm.card.exp_month}/${pm.card.exp_year})`;
    },
    // For rendering bank account details
    formatBankDetails(bank_account) {
      return `${bank_account.bank_name} Account ending in ${bank_account.last4}`;
    },
    // Formats the payment methods received from Stripe for Sources and "Payment Methods" aka credit card
    formatOptions() {
      let array = [];
      this.payment_methods.forEach((pm) => {
        if (pm.object == "payment_method" && pm.id !== this.default.id) {
          let pmObject = {
            text: this.formatCardDetails(pm),
            value: pm,
          };
          array.push(pmObject);
        } else if (pm.object == "bank_account" && pm.id !== this.default.id) {
          let baObject = {
            text: this.formatBankDetails(pm),
            value: pm,
          };
          array.push(baObject);
        }
      });
      this.pm = array;
    },
    // show the existing payment method modal
    showExistingPM() {
      this.formatOptions();
      this.existingPM = true;
    },
    // Emits setPM event, interpretted by parent element
    setPM() {
      this.$emit("setPM", this.selectedPM);
      this.$refs.existingPM.hide();
    },
    // Emits newPM event, interpretted by parent element
    newPMSaved(saved) {
      this.$emit("newPM", saved);
      this.$refs.newPM.hide();
    },
  },
  data() {
    return {
      pm: [],
      selectedPM: "",
      existingPM: false,
    };
  },
};
</script>

<template>
  <div>
    <b-modal ref="mainModal" :id="modalId" size="m">
      <b-row>
        <b-col cols="3" />
        <b-col cols="6">
          <b-row>
            <b-button size="lg" variant="light" @click="showExistingPM">
              Choose an Existing Payment Method
            </b-button>
          </b-row>
          <div class="or" align="center">----- OR -----</div>
          <b-row>
            <b-button size="lg" variant="light" v-b-modal.newPM>
              Add a New Payment Method
            </b-button>
          </b-row>
        </b-col>
        <b-col cols="3" />
      </b-row>
      <template #modal-footer>
        <div class="float-right"></div>
      </template>
    </b-modal>

    <b-modal size="xl" ref="newPM" id="newPM" title="Add a New Payment Method">
      <div>
        <div class="spacer" />
        <b-row align-h="center">
          <b-col lg="4" xl="4" md="4" sm="4" cols="4">
            <div style="align: center">
              <PlaidLink @savedBA="this.newPMSaved" />
            </div>
          </b-col>
        </b-row>
        <div class="spacer" />
        <div style="text-align: center">
          <p class="or">OR</p>
        </div>
        <b-row align-h="center">
          <b-col md="9" lg="9" xl="9">
            <div class="spacer" />
            <div>
              <CreditCardElement @savedCC="this.newPMSaved" />
            </div>
            <div class="spacer" />
          </b-col>
        </b-row>
      </div>
      <template #modal-footer>
        <div></div>
      </template>
    </b-modal>

    <b-modal
      size="m"
      ref="existingPM"
      id="existingPM"
      title="Existing Payment Methods"
      v-model="existingPM"
    >
      <p>Please select one of your existing payment methods.</p>

      <b-form-radio-group
        id="pm-form-group"
        v-if="pm"
        :options="pm"
        v-model="selectedPM"
        stacked
      ></b-form-radio-group>
      <template #modal-footer>
        <div class="float-right">
          <b-button class="mr-3" variant="primary" @click="setPM">
            Submit
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<style lang="css" scoped>
.button-group {
  align-items: center;
}
.spacer {
  height: 30px;
}
.or {
  font-size: 20px;
}
</style>
